import { getHostURL } from '../utils/GeneralUtil';
import { assets } from '../images/AssetPaths';
// General
var accountManagementEmail = 'ProXtraLoyaltyVIP@homedepot.com';
export var links = {
    faqTermsAndConditions: getHostURL('c/pro-xtra-terms-and-conditions'),
    termsAndConditionsTitle: 'Pro Xtra Terms & Conditions',
};
export var tierBadges = {
    MEMBER: {
        icon: assets.tierBadge.MEMBER,
        label: 'MEMBER',
    },
    ELITE: {
        icon: assets.tierBadge.ELITE,
        label: 'ELITE',
    },
    VIP: {
        icon: assets.tierBadge.VIP,
        label: 'VIP',
    },
};
export var offerErrorMessage = {
    line1: 'Something went wrong.',
    line2: 'Please try refreshing these offers.',
};
// Cards
export var cards = {
    ProXtraPerks: {
        cardName: 'ProXtraPerksCard',
        icon: assets.cardIcons.ProXtraPerks,
        title: 'Pro Xtra Perks',
        caption: {
            desktop: "Earn money-saving rewards, like Pro Xtra Dollars and Tool Rental Perks.",
            error: ['Something went wrong.', 'Please try again later.'],
            availablePerks: "Thanks for your loyalty. Enjoy your Pro Xtra Perks before they expire.",
            newUnlockedPerk: "You\u2019ve unlocked a new Perk. See your dashboard to make your Perk choice.",
            wellDone: "You\u2019ve unlocked your final Pro Xtra Perk for this year. You still have time to enjoy all of your previously unlocked Perks.",
        },
        subtitle: {
            error: [
                'Currently, you have no Available Perks.',
                'Check back again soon!',
            ],
        },
        cta: {
            label: 'View Your Perks',
            path: getHostURL('myaccount/proXtraPerks'),
            consumerApp: 'homedepot://view/proxtraperks',
        },
        footer: "Earn money-saving rewards, like Pro Xtra Dollars and Tool Rental Perks, just for shopping at The Home Depot. It\u2019s the best way to get the most out of every dollar you spend.",
    },
    PaintRewards: {
        cardName: 'PaintRewardsCard',
        icon: {
            MEMBER: assets.cardIcons.PaintRewards_Member,
            BRONZE: assets.cardIcons.PaintRewards_Bronze,
            SILVER: assets.cardIcons.PaintRewards_Silver,
            GOLD: assets.cardIcons.PaintRewards_Gold,
        },
        title: {
            MEMBER: 'Paint Rewards',
            BRONZE: 'Bronze Paint Rewards',
            SILVER: 'Silver Paint Rewards',
            GOLD: 'Gold Paint Rewards',
        },
        tooltip: 'Qualifying purchases for Paint Spend include all paint-supply purchases. You must identify as a Pro Xtra Member at checkout.',
        subtitle: {
            desktop: {
                MEMBER: null,
                BRONZE: "You're Earning 10% Off on Paint Products",
                SILVER: "You're Earning 15% Off on Paint Products",
                GOLD: "You're Earning 20% Off on Paint Products",
            },
            mobile: {
                MEMBER: 'Pro Xtra Paint Rewards',
                BRONZE: 'Bronze Paint Rewards',
                SILVER: 'Silver Paint Rewards',
                GOLD: 'Gold Paint Rewards',
            },
        },
        caption: {
            desktop: {
                MEMBER: 'Save 10% on 1 gallon or larger paints, stains, primers and solvents when you spend $1,000 and unlock Bronze Paint Rewards. Automatically get Bronze savings when you reach Pro Xtra Elite status.',
                BRONZE: null,
                SILVER: 'Save 20% on 1 gallon or larger paints, stains, primers and solvents when you spend $6,500 and unlock Gold Paint Rewards. Automatically get Gold savings when you reach Pro Xtra VIP status.',
                GOLD: null,
            },
            mobile: {
                MEMBER: 'Save 10% on 1 gallon or larger paints, stains, primers and solvents when you spend $1,000 and unlock Bronze Paint Rewards. Automatically get Bronze savings when you reach Pro Xtra Elite status.',
                BRONZE: "You're Earning 10% Off on Paint Products",
                SILVER: "You're Earning 15% Off on Paint Products",
                SILVERUPTIER: 'Save 20% on 1 gallon or larger paints, stains, primers and solvents when you spend $6,500 and unlock Gold Paint Rewards. Automatically get Gold savings when you reach Pro Xtra VIP status.',
                GOLD: "You're Earning 20% Off on Paint Products",
            },
        },
        cta: {
            label: 'View Paint Rewards Details',
            historyLabel: 'View Your Rewards History',
            path: getHostURL('myaccount/proXtraPricing'),
            consumerApp: 'homedepot://view/proxtrapricing',
        },
        rewardsHistory: {
            title: 'Paint Rewards History',
            spendTiers: {
                title: 'Paint Spend Tiers',
                bronze: 'Save 10% when you spend $1,000 in paint products or reach Pro Xtra Elite status.',
                silver: 'Save 15% when you spend $3,500 in paint products.',
                gold: 'Save 20% when you Spend $6,500 in paint products or reach Pro Xtra VIP status.',
            },
            adjustmentHistory: {
                title: 'Paint Tier Adjustment History',
                columns: [
                    ['Effective', 'Date'],
                    ['Tier', 'Adjustment'],
                    ['Description'],
                ],
            },
            qualificationDetails: {
                title: 'Paint Tier Qualification Details',
                paragraphs: [
                    "When your paint tier (Bronze, Silver, Gold) or Pro Xtra loyalty tier (Member, Elite, VIP) for the current year (January 1-December 31) reaches a tier threshold, you\u2019ll receive the paint savings applicable to that tier.",
                    "Your tier savings will be valid for the remainder of the current year and the full following year.",
                    "Qualifying purchases for paint spend include all paint-supply purchases. You must identify as a Pro Xtra member at checkout.",
                ],
            },
        },
    },
    OfferChallenges: {
        cardName: 'OfferChallengeCard',
        icon: assets.cardIcons.PersonalOffers,
        title: 'Offer Challenge',
        caption: {
            error: ['Something went wrong.', 'Please try again later.'],
        },
        acceptedError: 'Something went wrong. Please try again later.',
        cta: 'View Details',
        receiveReward: 'Receive Your Reward',
        toComplete: 'To Complete the Challenge:',
        beginChallenge: 'To begin the challenge, select the button below.',
        redeemInStoreConstant: 'Your Pro Xtra Dollars reward will be added to your Personalized Offers. Redeem your reward online or in store, and keep scanning your Virtual ID in the The Home Depot App every time you check out to easily apply savings, track purchases and earn towards your next perk.',
    },
};
